/**
 * Tipi TypeScript per autenticazione
 * Corrispondono agli schemi Pydantic del backend
 */

import { CompanyType } from './admin';

export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  COMPANY_ADMIN = 'company_admin',
  OPERATOR = 'operator',
  VIEWER = 'viewer',
}

/**
 * Request per login
 */
export interface LoginRequest {
  email: string;
  password: string;
}

/**
 * Informazioni utente incluse nella risposta del token
 */
export interface UserInfo {
  user_id: string;
  email: string;
  full_name: string;
  role: UserRole;
  company_id: string | null;
  company_type: CompanyType | null;
  is_active: boolean;
  // Profile fields
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  job_title?: string | null;
  department?: string | null;
  avatar_url?: string | null;
  timezone?: string | null;
  preferred_language?: string | null;
}

/**
 * Risposta del token JWT
 */
export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number; // seconds
  user: UserInfo;
}

/**
 * Request per refresh token
 */
export interface RefreshRequest {
  refresh_token: string;
}

/**
 * Risposta generica con messaggio
 */
export interface MessageResponse {
  message: string;
}

/**
 * Request per forgot password
 */
export interface ForgotPasswordRequest {
  email: string;
}

/**
 * Risposta per verifica token reset password
 */
export interface ResetPasswordVerifyResponse {
  valid: boolean;
  email?: string;
}

/**
 * Request per reset password
 */
export interface ResetPasswordRequest {
  token: string;
  password: string;
  password_confirm: string;
}

